export interface GAEBTextParts {
  shortText?: string | null;
  longText?: string | null;
  ourComment?: string | null;
}

function normalizeMultiline(value?: string | null): string | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }

  let normalized = value;

  // Remove Microsoft Office (MSO) CSS artifacts like "mso-tab-count:1;" or "mso-spacerun:yes"
  // These come from Word/Excel copy-paste operations in GAEB source files
  normalized = normalized.replace(/mso-[a-z\-]+\s*:\s*[^;]*;?\s*/gi, '');

  // Remove orphaned semicolons that might remain after MSO cleanup
  normalized = normalized.replace(/;\s*;/g, ';');
  normalized = normalized.replace(/^\s*;+\s*$/gm, '');

  // Standard newline normalization
  normalized = normalized
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .split('\n')
    .map((line) => line.trimEnd())
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();

  return normalized.length > 0 ? normalized : undefined;
}

function stripDuplicatePrefix(longText: string, shortText: string): string {
  const normalizedShort = shortText.trim();
  if (!normalizedShort) {
    return longText;
  }

  const lowerShort = normalizedShort.toLowerCase();
  const lowerLong = longText.toLowerCase();

  if (lowerLong.startsWith(lowerShort)) {
    const stripped = longText.slice(normalizedShort.length).trimStart();
    return stripped.length > 0 ? stripped : '';
  }

  return longText;
}

export function composeGAEBDescription(parts: GAEBTextParts): string {
  const shortText = normalizeMultiline(parts.shortText);
  const rawLongText = normalizeMultiline(parts.longText);
  const ourComment = normalizeMultiline(parts.ourComment);

  const segments: string[] = [];

  if (shortText) {
    segments.push(shortText);
  }

  if (rawLongText) {
    const longText = shortText
      ? stripDuplicatePrefix(rawLongText, shortText)
      : rawLongText;

    if (longText.trim()) {
      segments.push(longText.trim());
    }
  }

  if (ourComment) {
    segments.push(`Hinweis: ${ourComment}`);
  }

  return segments.join('\n\n').trim();
}

export function normalizeGAEBLongText(value?: string | null): string | undefined {
  return normalizeMultiline(value);
}

